import { getImageFromPage } from '~core';
import { getMetadata } from '~loader/loader-utils';
import slugify from 'slugify';
import { jsPDF } from 'jspdf';
import { getSelectedPagesByUser } from '../../getSelectedPagesByUser';
import { addWatermark } from '~src/utils';
import { getUser } from '~src/user';
import { getGridParameters } from '~core/grigliaProvino';

const staticGridParameters = {
  pdf: {
    topMargin: 13,
    leftMargin: 6,
  },
  rowInfo: {
    maxItemsToFit: 2,
    padding: 4,
  },
  columnInfo: {
    maxItemsToFit: 5,
    padding: 0,
  },
};

export default async function generateGrid() {
  const metadata = getMetadata();
  const selectedPagesByUser = getSelectedPagesByUser();

  const { user } = await getUser();

  const gridParameters = getGridParameters();

  const pdfGrid = new jsPDF(gridParameters.pdf.orientation, 'mm', [
    gridParameters.pdf.width,
    gridParameters.pdf.height,
  ]);

  let pageNumber = 0;

  for (let page of selectedPagesByUser) {
    pageNumber++;
    if (pageNumber > 1) {
      pdfGrid.addPage();
    }

    let image = await getImageFromPage(page);
    if (user.org_pointer.tipo_istanza === 'demo') {
      image = await addWatermark(image);
    }
    let left = staticGridParameters.pdf.leftMargin;
    let top = staticGridParameters.pdf.topMargin;

    for (let j = 0; j < staticGridParameters.rowInfo.maxItemsToFit; j++) {
      for (let i = 0; i < staticGridParameters.columnInfo.maxItemsToFit; i++) {
        pdfGrid.addImage(
          image,
          'JPEG',
          left,
          top,
          gridParameters.format.width,
          gridParameters.format.height
        );
        left +=
          gridParameters.format.width + staticGridParameters.columnInfo.padding;
      }
      left = staticGridParameters.pdf.leftMargin;
      top =
        staticGridParameters.pdf.topMargin +
        gridParameters.format.height * (j + 1) +
        staticGridParameters.rowInfo.padding;
    }
  }

  const fileName = slugify(
    `Provino-${metadata.projectTypeName}${
      metadata.templatesCategoryName ? `-${metadata.templatesCategoryName}` : ''
    }${metadata.servizioName ? `-${metadata.servizioName}` : ''}${
      metadata.formatName ? `-${metadata.formatName}` : ''
    }.pdf`
  );

  return { pdfGrid, fileName };
}
